/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "RegenerateStatementsRequest": {
                "fields": {
                  "planToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "RegenerateStatementsResponse": {
                "fields": {
                  "success": {
                    "type": ".squareup.corporate_card.service.RegenerateStatementsResponse.Success",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Success": {
                    "fields": {}
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RegenerateStatementsRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RegenerateStatementsResponse && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RegenerateStatementsResponse?.nested?.Success) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RegenerateStatementsRequest @ squareup/corporate_card/service/regenerate_statements.proto at 9:1
 */
export const RegenerateStatementsRequest = $root.lookupType('squareup.corporate_card.service.RegenerateStatementsRequest');
fixType(RegenerateStatementsRequest, {
  planToken: {
    required: true
  },
  reason: {
    required: true
  }
});
Builder.createAndAttachToType(RegenerateStatementsRequest);
/**
 * SOURCE RegenerateStatementsResponse @ squareup/corporate_card/service/regenerate_statements.proto at 17:1
 */
export const RegenerateStatementsResponse = $root.lookupType('squareup.corporate_card.service.RegenerateStatementsResponse');
fixType(RegenerateStatementsResponse);
Builder.createAndAttachToType(RegenerateStatementsResponse);
/**
 * SOURCE Success @ squareup/corporate_card/service/regenerate_statements.proto at 18:3
 */
RegenerateStatementsResponse.Success = $root.lookupType('squareup.corporate_card.service.RegenerateStatementsResponse.Success');
fixType(RegenerateStatementsResponse.Success);
Builder.createAndAttachToType(RegenerateStatementsResponse.Success);